/**
 *  Load libs
 */
import libs from './libs/swiper.min';
/**
 *  Load plugins
 */

import plugins from './plugins/plugins';

/**
 *  Load modules
 */

import headerHav from './modules/header-nav.js';
import accordion from './modules/accordion.js';
import loadMore from './modules/load-more.js';
import smoothScroll from './modules/smoothScroll.js';
import swiper from './modules/swiper.js';
import select from './modules/customSelect.js';
import jobs from './modules/jobs';
import testimonials from './modules/testimonials';
import formVacancy from './modules/form-vacancy.js';
import faq from './modules/faq.js';
import custom from './modules/custom.js';
import initHoverVideoSlider from './modules/hover-video.js';
import initMapSection from './modules/map-section.js';
import initAutoSlider from './modules/auto-slider.js';
import initBlog from './modules/blog.js';
import initPress from './modules/press.js';
import '../scss/app.scss';
$(function () {
  headerHav();
  accordion();
  loadMore();
  smoothScroll();
  swiper();
  select();
  jobs();
  testimonials();
  formVacancy();
  faq();
  custom();
  initHoverVideoSlider();
  initMapSection();
  initAutoSlider();
  initBlog();
  initPress();
});